module.exports = __webpack_public_path__ + "img/mini-006.47aa5ae2.jpg";